// These globals are replaced at build time by Vite's `define` in the consuming
// app.  When the module is loaded outside that pipeline (e.g. vitest in a
// different workspace package) the globals won't exist, so fall back to safe
// defaults.
declare const __DEV_WATCH__: boolean;
declare const __LOGGING_FILTER__: string;

const isDevWatch = typeof __DEV_WATCH__ !== "undefined" && __DEV_WATCH__;
const loggingFilter =
  typeof __LOGGING_FILTER__ !== "undefined" ? __LOGGING_FILTER__ : "*";

const getEnabledNamespaces = () => {
  // Split by comma and filter out empty strings
  return loggingFilter
    .split(",")
    .map((ns) => ns.trim())
    .filter(Boolean);
};

const ENABLED_NAMESPACES = new Set<string>(getEnabledNamespaces());
const filterNameSpace = (namespace: string) => {
  if (ENABLED_NAMESPACES.has("*")) return true;

  return ENABLED_NAMESPACES.has(namespace);
};

// Create a logger for a specific namespace
export const createLogger = (namespace: string) => {
  // Logger functions that only activate in dev-watch mode
  const logger = {
    debug: (message: string, ...args: unknown[]) => {
      if (isDevWatch && filterNameSpace(namespace))
        console.debug(`[${namespace}] ${message}`, ...args);
    },

    info: (message: string, ...args: unknown[]) => {
      if (isDevWatch && filterNameSpace(namespace))
        console.info(`[${namespace}] ${message}`, ...args);
    },

    warn: (message: string, ...args: unknown[]) => {
      if (isDevWatch && filterNameSpace(namespace))
        console.warn(`[${namespace}] ${message}`, ...args);
    },

    // Always log errors, even in production
    error: (message: string, ...args: unknown[]) => {
      console.error(`[${namespace}] ${message}`, ...args);
    },

    // Lazy evaluation for expensive logs
    debugIf: (fn: () => string) => {
      if (isDevWatch && filterNameSpace(namespace))
        console.debug(`[${namespace}] ${fn()}`);
    },
  };

  return logger;
};
